import { withSvgIcon } from './withSvgIcon';

export const Calendar = withSvgIcon(
  <path
    d="M4 11V7C4 5.89543 4.89543 5 6 5H9M4 11V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V11M4 11H20M20 11V7C20 5.89543 19.1046 5 18 5H15M9 5V4M9 5V7M9 5H15M15 5V4M15 5V7"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
